import * as React from "react"
import Layout from "@components/layout"
import Video from "@images/video-es.mp4"

const IndexPage = () => (
  <Layout>
    <section className="fullsize-video-bg">
        <video style={{height: "100%", width: "100%"}} autoPlay muted>
          <source src={Video} type="video/mp4" />
        </video>

    </section>

  </Layout>
)

export default IndexPage
